import { atom, selector } from 'recoil';
import { getFeatureFlags } from '../repositories/HttpRepository';

/**
 * Feature flags atom - stores the current feature flag states
 * Fetched from backend on app startup
 */
export const featureFlagsAtom = atom({
  key: 'featureFlagsAtom',
  default: null, // null until loaded from backend, enables env var fallback
});

/**
 * Feature flags loading state
 */
export const featureFlagsLoadingAtom = atom({
  key: 'featureFlagsLoadingAtom',
  default: true,
});

/**
 * Selector to fetch feature flags from the backend
 * Used for initial load
 */
export const featureFlagsSelector = selector({
  key: 'featureFlagsSelector',
  get: async () => {
    try {
      const response = await getFeatureFlags();
      if (response.ok && response.data) {
        return response.data;
      }
      // Return defaults if fetch fails
      return {
        // no-dd-sa:javascript-inclusive/identifiers - "slaVersioning" is SLA (Service Level Agreement) + Versioning; substring match is a false positive
        slaVersioning: false,
      };
    } catch {
      // Return defaults on error
      return {
        // no-dd-sa:javascript-inclusive/identifiers - "slaVersioning" is SLA (Service Level Agreement) + Versioning; substring match is a false positive
        slaVersioning: false,
      };
    }
  },
});

/**
 * Feature flag names for type safety
 */
export const FEATURE_FLAGS = {
  // no-dd-sa:javascript-inclusive/identifiers - "slaVersioning" is SLA (Service Level Agreement) + Versioning; substring match is a false positive
  SLA_VERSIONING: 'slaVersioning',
};
